import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const renderOrderCategory = (orderCategory: string | null): string => {
  if (!orderCategory || orderCategory === "EMPTY") return "-";
  if (orderCategory === "h2") return "H-2";
  if (orderCategory === "kilat") return "KILAT";
  if (orderCategory === "j6") return "J-6";
  return orderCategory;
};

export const typeOptionsAbbr: { [key: string]: { nama: string | null } } = {
  "all": { nama: "All Types" },
  "pesanan_toko": { nama: "OTS" },
  "preorder": { nama: "POC" },
  "order_to_deliver": { nama: "OTDC" },
  "-": { nama: null }
};
